import { EditOutlined } from "@ant-design/icons";
import React from "react";

import "./stylesSummary.css";
import { Input } from "antd";
import { AppStrings } from "../../../../utils/constants/AppStrings";

function Summary() {
  return (
    <div className="summary-container">
      <h2>{AppStrings.SUMMARY}</h2>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>{AppStrings.PROMO_DETAILS}</h3>
          <div className="summary-editing">
            <span>{AppStrings.EDIT}</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div className="campaign-name">
          <span>{AppStrings.ENTER_CAMPAIGN_NAME}</span>
          <Input placeholder={AppStrings.ENTER_CAMPAIGN_NAME} />
        </div>
        <div className="promo-details-body">
          <div className="left-content">
            <div className="channels">
              <span>{AppStrings.DESCRIPTION}</span>
              <p>
                {AppStrings.PROMO_DESCRIPTION}
              </p>
            </div>
            <div className="channels">
              <span>{AppStrings.END_DATE}</span>
              <p>20 September, 2024 at 10:32 AM (players local time zone)</p>
            </div>
            <div className="channels">
              <span>{AppStrings.DEPOSIT_MATCH_PERCENTAGE}</span>
              <p>100%</p>
            </div>
            <div className="channels">
              <span>{AppStrings.MAX_BONUS_AMOUNT}</span>
              <p>$100</p>
            </div>
          </div>
          <div className="right-content">
            <div className="channels">
              <span>{AppStrings.START_DATE}</span>
              <p>20 September, 2024 at 10:32 AM (players local time zone)</p>
            </div>
            <div className="channels">
              <span>{AppStrings.EXPIRATION_PERIOD}</span>
              <p>7 days</p>
            </div>
            <div className="channels">
              <span>{AppStrings.MIN_BONUS_AMOUNT}</span>
              <p>-</p>
            </div>
            <div className="channels">
              <span>{AppStrings.TERMS_OF_USE}</span>
              <p>
                <b>Participation Period:</b> <br /> The promotion is applicable
                for any eligible transactions made between February 10th, 00:00
                GMT, and February
              </p>
            </div>
            <span className="show-more">{AppStrings.SHOW_MORE}</span>
          </div>
        </div>
      </section>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>{AppStrings.MESSAGING}</h3>
          <div className="summary-editing">
            <span>{AppStrings.EDIT}</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div className="channels">
          <span>{AppStrings.CHANNELS}</span>
          <p>
            {AppStrings.EMAIL} <span>{AppStrings.AND}</span> {AppStrings.IOS_PUSH} <span>{AppStrings.AND}</span> {AppStrings.PURCHASE_MATCH}
          </p>
        </div>
      </section>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>{AppStrings.SCHEDULED_DELIVERY}</h3>
          <div className="summary-editing">
            <span>{AppStrings.EDIT}</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div>
          <div className="channels">
            <span>{AppStrings.TIME_BASED_SCHEDULING_OPTIONS}</span>
            <p>
              {AppStrings.PAM_NEW_PROMOTION_SEND_AS_SOON_LOCAL}
            </p>
          </div>
          <div className="channels">
            <span>{AppStrings.HOW_OFTEN_TO_SEND}</span>
            <p>Once, 20 September, 2024 at 10:32 AM</p>
          </div>
          <div className="channels">
            <span>{AppStrings.NEXT_SEND_TIME}: </span>
            <p>20 September, 2024 at 10:32 AM</p>
          </div>
        </div>
      </section>
      <section className="summary-messaging">
        <div className="summary-messaging-header">
          <h3>{AppStrings.TARGET_AUDIENCES}</h3>
          <div className="summary-editing">
            <span>{AppStrings.EDIT}</span> <EditOutlined className="summary-edit-icon" />
          </div>
        </div>
        <div className="channels">
          <div className="channels-row">
            <div style={{ width: "50%" }}>
              <h4>{AppStrings.TARGETING_OPTIONS}</h4>
              <span>{AppStrings.TARGET_PLAYERS_BY_SEGMENT}</span>
              <p>
                01. All time 25% + GGR {">"} 0 and 05. $1,000 + deposited last
                month {">"} 0
              </p>
            </div>
            <div style={{ width: "50%" }}>
              <h4>{AppStrings.A_B_TESTING}</h4>
              <span>{AppStrings.CONTROL_GROUP}</span>
              <p>50% </p>
            </div>
          </div>
        </div>
        <div className="channels" style={{ width: "100%" }}>
          <div className="channels-row">
            <div style={{ width: "50%" }}>
              <span>{AppStrings.TARGET_PLAYERS_BY_SEGMENT}</span>
              <p>
                Min. number of bets last month = 5 or Min. number of bets last
                month = 1
              </p>
            </div>
            <div style={{ width: "50%" }}>
              <span>{AppStrings.VARIANT_1}</span>
              <p>50% </p>
            </div>
          </div>
        </div>
        <div className="channels" style={{ width: "50%" }}>
          <span>{AppStrings.PLAYERS_LOCATION}</span>
          <p>{AppStrings.PAM_NEW_PROMOTION_ALL_STATES} </p>
        </div>
      </section>
    </div>
  );
}

export default Summary;
